<template>
    <!-- <FinalPreview v-if="finalPdfSourche === null" :pdfSource="pdfSourcePreview" /> -->
    <v-container
        v-if="!isLoading" 
        fluid class="elevation-5 d-flex justify-center" >
        <v-row>
            <!-- Slides von Latex -->
            <v-col cols="2" class="pa-0 d-flex"  >
                <SlidesOriginalPreview 
                  v-if="pdfSource !== undefined || pdfSource !== '' " 
                  :pdfSource="pdfSource" 
                  :frames="frames"
                  @newSelectedFrame="newSelecetedFrameHandling" />
            </v-col>

            <v-divider :thickness="2" class="pl-5" vertical></v-divider>

            <!-- View -->
            <v-col cols="6" offset="1" class="ml-10" style="position: relative;" >
               <div 
                 v-if="currentFrame?.isReplaced && currentFrame?.template?.pdfSource !== undefined && currentFrame?.selectedSlideTemplate?.pageNumber" 
                 class="absolute"
                 >
                    <v-card 
                        class="pa-2"
                        style="position: absolute; top: 0; right: 0; width: 200px; z-index: 10;"
                        elevation="5"
                        v-motion-slide-top
                    >
                        <SlidePreview 
                        clearable 
                        :pdfSource="currentFrame?.template.pdfSource" 
                        :currentPage="currentFrame?.selectedSlideTemplate?.pageNumber"
                        :style="{ cursor: 'pointer' }" 
                        @click="setPreview(currentFrame?.template.pdfSource, currentFrame?.selectedSlideTemplate?.pageNumber);"
                        />
                    </v-card>
                </div>
                <SlidePreview 
                    :pdfSource="pdfSourcePreview" 
                    :currentPage="pagePreview"
                />
                <v-btn 
                    v-if="!currentFrame?.isReplaced  && currentFrame?.template?.pdfSource !== undefined"
                    class="ma-2 pa-2 elevation-5 text-none"
                    append-icon="mdi-sticker-plus-outline"
                    @click="setRepacedFrame()"
                >Ersetzen</v-btn>

                <v-btn 
                v-if="currentFrame?.isReplaced  && currentFrame?.template?.pdfSource !== undefined"
                class="ma-2 pa-2 elevation-5 text-none"
                append-icon="mdi-sticker-minus-outline"
                @click="removeReplaced()"
                >Entfernen</v-btn>

                <v-btn 
                    class="ma-2 pa-2 elevation-5 text-none"
                    append-icon="mdi-chevron-down "
                    @click="showDetails = !showDetails"
                >Deteils zeigen</v-btn>
                <v-divider :thickness="2" class="pl-5" vertical></v-divider>
                <!-- Details -->
                <SlideDetails v-if="currentFrame && showDetails" :frame="currentFrame" />
            </v-col>


            <v-divider :thickness="2" class="pl-12" vertical></v-divider>

            <!-- Designer -->
            <v-col cols="3" >
                <SlideDesginPreview 
                  :isInProcess="isInProcess"
                  :currentFrame="currentFrame"
                  :isInProcessOfNewGenerating="isNewGenerating"
                  @generateLayoutsSuggestions="generateLayoutSuggestionsHandling"
                  @selectedSuggestedLayout="selectedSuggestedLayoutHeandling"
                  @generateAgainSuggestions="generateAgainLayoutSuggestionsHandling"
                 />               

                 <v-btn 
                    class="ma-2 pa-2 elevation-5 text-none"
                    append-icon="mdi-download-box-outline"
                    @click="generateLatex()"
                >Präsentation herunterladen</v-btn>
            </v-col>
        </v-row>
    </v-container>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SlidesOriginalPreview from './SlidesOriginalPreview.vue';
import SlideDesginPreview from './SlideDesignPreview.vue';
import SlidePreview from './SlidePreview.vue';
import SlideDetails from './SlideDetails.vue';
import { sectionsService } from '@/services/section.service';
import { Section } from '@/types/section';
import { Frame } from '@/types/frame';
import { frameService } from '@/services/frame.service';
import { templateService } from '@/services/template.service';
import { FinalData } from '@/types/finaldata';

export default defineComponent({
    name: 'SlideStudioView-Componenten',

    props: {
        zip: File,
    },

    components: {
        SlidesOriginalPreview,
        SlidePreview,
        SlideDesginPreview,
        SlideDetails,
    },

    data() {
        return {
            pdfSource: "" as string,
            isClickedSlideFromDesigner: false as boolean,

            isInProcess: false as boolean,
            isNewGenerating: false as boolean,

            pdfSourcePreview: "" as string,
            pagePreview: 1 as number,

            sections: [] as Section[],
            currentFrame: null as Frame | null,

            clickedPageDesign: 1 as number,
            clickedPageOriginal: 1 as number,
            isPageOriginalInSlidePreviewActive: true as boolean,

            showDetails: false as boolean,
            isLoading: false as boolean,

            finalPdfSourche: null as string | null,
            frames: [] as Frame[],
        };
    },
    methods: {

        // Async Area
        async convertLatexToPDF() {
            this.setLoading(true);
            if (this.zip == null) {
                return;
            }
            const data = await sectionsService.convertToPDF(this.zip);
            if(data === null || data === undefined){
                return;
            }
            if(data?.pdfSource !== undefined && data.pdfSource !== null && data?.sections !== undefined && data.sections!== null){
                this.pdfSource = data.pdfSource;
                this.sections = data.sections;
                this.setPreview(this.pdfSource, 1);
                this.setCurrentFrame(this.clickedPageOriginal);
                this.setLoading(false);
            }
        },
        async generateLayouts(frame: Frame, isNewGenerating: boolean = false) {
            if(frame === null || frame === undefined){
                return;
            }
            const frameWithSuggestions = await frameService.generateLayoutsSuggestions(frame);
            if (frameWithSuggestions != null || frameWithSuggestions != undefined){ 
                this.currentFrame = sectionsService.updateFrame(this.sections, frameWithSuggestions);
            }
            if(isNewGenerating){
                this.isNewGenerating = false;
            }else{
                this.isInProcess = false;
            }

        },

        async generateLatex(){
            if(this.sections === null || this.sections === undefined || this.zip === null || this.zip === undefined){
                return;
            }
            this.setLoading(true);
            const finalData = await sectionsService.generateLatex(this.zip, this.sections);
            if(finalData !== null && finalData.finalFile !== null && finalData.finalPdfSource !== null){
                // reset all
                this.sections = [];
                this.currentFrame = null;
                this.pdfSource = "";
                this.pdfSourcePreview = "";
                this.setFinalPreview(finalData);
            }
            
            return
        },


        // Help Functions Area
        setCurrentFrame(page: number) {
            if(this.sections === null || this.sections === undefined){
                return;
            }

            const currentFrame = sectionsService.getFrameByNumber(this.sections, page);
            if(currentFrame !== null && currentFrame !== undefined){
                this.currentFrame = currentFrame;
            }
        },
        getContentOfCurrentFrame(): string{
            if(this.currentFrame === null || this.currentFrame === undefined){
                return "";
            }
            const frame = sectionsService.getFrameByNumber(this.sections, this.currentFrame.number);
            if(frame !== null && frame !== undefined){
                return frame.content;
            }
            return "";
        },
        setRepacedFrame() {
            if (this.currentFrame && this.currentFrame.template ) {
                const selectedSlideTemplate = templateService.getSlideTemplateByNumber(this.currentFrame.template, this.clickedPageDesign);
                if (selectedSlideTemplate === null || selectedSlideTemplate === undefined) {
                    console.error("No selected slide template found");
                    return;
                }
                selectedSlideTemplate.pageNumber = this.clickedPageDesign;
                this.currentFrame.selectedSlideTemplate = selectedSlideTemplate;
                this.currentFrame.isReplaced = true;
                this.currentFrame = sectionsService.updateFrame(this.sections, this.currentFrame);
                this.updateAllFrames();
            }
        },
        removeReplaced() {
            if (this.currentFrame && this.currentFrame.template) {
                this.currentFrame.isReplaced = false;
                this.currentFrame.selectedSlideTemplate = undefined;
                this.currentFrame = sectionsService.updateFrame(this.sections, this.currentFrame);
                this.updateAllFrames();

            }
        }, 

       getPdfSourceOfCurrentFrame(): string{
            if (this.currentFrame?.isGenerated && this.currentFrame.template?.pdfSource) {
                return this.currentFrame.template.pdfSource;
            }
            return "";
        },
        setPreview(pdfSource: string, page: number){
            this.pdfSourcePreview = pdfSource;
            this.pagePreview = page;
        },
        
        getPageForSelectedSlideTemplate(): number{
            if (this.currentFrame?.template && this.currentFrame?.selectedSlideTemplate) {
                const number = templateService.getNumberBySlideTemplate(this.currentFrame.template, this.currentFrame?.selectedSlideTemplate);
                if (number !== null && number !== undefined) { 
                    return number;
                }
            }
            return 1;
        },
        updateAllFrames(){
            if(this.sections === null || this.sections === undefined){
                return [];
            }
            this.frames = sectionsService.getAllFrames(this.sections);
        },
        // emits Handling Area
        newSelecetedFrameHandling(page: number){
            if (this.clickedPageOriginal === page) {
                return;
            }

            this.clickedPageOriginal = page;
            this.isPageOriginalInSlidePreviewActive = true;
            this.setCurrentFrame(this.clickedPageOriginal);
            this.setPreview(this.pdfSource, this.clickedPageOriginal);
        
        },
        generateLayoutSuggestionsHandling(should : boolean){
            if(should && this.currentFrame !== null){
                this.isInProcess = true;
                this.generateLayouts(this.currentFrame, false);
            }
        },
        generateAgainLayoutSuggestionsHandling(should : boolean){
            if(should && this.currentFrame !== null){
                this.isNewGenerating = true;
                this.generateLayouts(this.currentFrame, true);
            }
        },
        selectedSuggestedLayoutHeandling(page : number){
            this.clickedPageDesign = page;
            this.isPageOriginalInSlidePreviewActive = false;
            this.setPreview(this.getPdfSourceOfCurrentFrame(), page);
        },

        setLoading(isloading: boolean){
            this.isLoading = isloading;
            this.$emit("isLoading", isloading);
        },
        setFinalPreview(finalData: FinalData){
            if(finalData === null ){
                return;
            }
            this.$emit("finalPreview", finalData);
        }
        
     },
    watch: {
        currentPage(newPage: number) {
            this.setCurrentFrame(newPage);
            this.setPreview(this.pdfSource, newPage);
        },
        currentFrame(newFrame: Frame) {
            if(newFrame !== null && newFrame !== undefined){
                this.currentFrame = newFrame;
            }
        },
    },

    created() {
        this.convertLatexToPDF();
        this.updateAllFrames();
    },
});
</script>
